import {
  BatterPlayerReportResultDto,
  BatterSessionReportResultDto,
  BatterSingleSessionReportResultDto,
  ChartType,
  PitcherPlayerReportResultDto,
  PitcherSessionReportResultDto,
  PitcherSingleSessionReportResultDto,
  UmpireReportForAdminResultDto,
  UmpireReportForSessionResultDto,
  UmpireReportResultDto,
} from 'types/CodegenReportTypes';

import BatterApproachPerCountChart from 'components/GridTiles/BatterApproachPerCountChart/BatterApproachPerCountChart';
import BatterBallStrikeSummaryChart from 'components/GridTiles/BatterBallStrikeSummaryChart/BatterBallStrikeSummaryChart';
import BatterBallStrikeSummaryChartSidebar from 'components/GridTiles/BatterBallStrikeSummaryChart/BatterBallStrikeSummaryChartSidebar';
import BatterBattingStatsChart from 'components/GridTiles/BattingStatsChart/BattingStatsChart';
import BatterSessionTimelineChart from 'components/GridTiles/BatterSessionTimelineChart/BatterSessionTimelineChart';
import BatterSessionStatsByPitchTypeChart from 'components/GridTiles/BatterSessionStatsByPitchTypeChart/BatterSessionStatsByPitchTypeChart';
import BatterSessionStatsByPitchTypeChartSidebar from 'components/GridTiles/BatterSessionStatsByPitchTypeChart/BatterSessionStatsByPitchTypeChartSidebar';
import {
  BatterSessionTimelineChartSidebar_1,
  BatterSessionTimelineChartSidebar_2,
  BatterSessionTimelineChartSidebar_3,
  BatterSessionTimelineChartSidebar_4,
} from 'components/GridTiles/BatterSessionTimelineChart/BatterSessionTimelineChartSidebar';
import BatterSingleSessionContactPointChart from 'components/GridTiles/BatterSingleSessionContactPointChart/BatterSingleSessionContactPointChart';
import BatterSingleSessionPitchByPitchStatsChart from 'components/GridTiles/BatterSingleSessionPitchByPitchStatsChart/BatterSingleSessionPitchByPitchStatsChart';
import BatterSingleSessionPitchLocationChart from 'components/GridTiles/BatterSingleSessionPitchLocationChart/BatterSingleSessionPitchLocationChart';
import BatterSingleSessionGameStatsChart from 'components/GridTiles/BatterSingleSessionGameStatsChart/BatterSingleSessionGameStatsChart';
import BatterSingleSessionGameStatsChartSidebar from 'components/GridTiles/BatterSingleSessionGameStatsChart/BatterSingleSessionGameStatsChartSidebar';
import BatterSingleSessionPitchByPitchStatsChartSidebar from 'components/GridTiles/BatterSingleSessionPitchByPitchStatsChart/BatterSingleSessionPitchByPitchStatsChartSidebar';
import BatterSingleSessionPitchLocationChartSidebar from 'components/GridTiles/BatterSingleSessionPitchLocationChart/BatterSingleSessionPitchLocationChartSidebar';
import BatterSingleSessionGameStatHighlightChart from 'components/GridTiles/BatterSingleSessionBattingStatChart/BatterSingleSessionBattingStatChart';
import {
  BatterSingleSessionBattingStatChartSidebar_1,
  BatterSingleSessionBattingStatChartSidebar_2,
  BatterSingleSessionBattingStatChartSidebar_3,
  BatterSingleSessionBattingStatChartSidebar_4,
  BatterSingleSessionBattingStatChartSidebar_5,
  BatterSingleSessionBattingStatChartSidebar_6,
} from 'components/GridTiles/BatterSingleSessionBattingStatChart/BatterSingleSessionBattingStatChartSidebar';
import BatterUsedPitchTypesChart from 'components/GridTiles/BatterUsedPitchTypesChart/BatterUsedPitchTypesChart';
import BatterUsedPitchTypesChartSidebar from 'components/GridTiles/BatterUsedPitchTypesChart/BatterUsedPitchTypesChartSidebar';
import BattingStatsChartSidebar from 'components/GridTiles/BattingStatsChart/BattingStatsChartSidebar';
import PitchesPerCountChart from 'components/GridTiles/PitchesPerCountChart/PitchesPerCountChart';
import PitcherBallTrackingStatsChart from 'components/GridTiles/PitcherBallTrackingStatsChart/PitcherBallTrackingStatsChart';
import PitcherBallTrackingStatsChartSidebar from 'components/GridTiles/PitcherBallTrackingStatsChart/PitcherBallTrackingStatsChartSidebar';
import PitcherSessionPitchTypeRangesChart from 'components/GridTiles/PitcherSessionPitchTypeRangesChart/PitcherSessionPitchTypeRangesChart';
import PitcherSessionStatsByPitchTypeChart from 'components/GridTiles/PitcherSessionStatsByPitchTypeChart/PitcherSessionStatsByPitchTypeChart';
import PitcherSessionTiltChart from 'components/GridTiles/PitcherSessionTiltChart/PitcherSessionTiltChart';
import { PlayerLineChart, PlayerTimelineChart } from 'components/PlayerLineChart/PlayerLineChart';
import PitcherSessionStatsByPitchTypeChartSidebar from 'components/GridTiles/PitcherSessionStatsByPitchTypeChart/PitcherSessionStatsByPitchTypeChartSidebar';
import PitcherSessionPitchTypeRangesChartSidebar from 'components/GridTiles/PitcherSessionPitchTypeRangesChart/PitcherSessionPitchTypeRangesChartSidebar';
import {
  PitcherSessionTimelineChartSidebar_1,
  PitcherSessionTimelineChartSidebar_2,
  PitcherSessionTimelineChartSidebar_3,
  PitcherSessionTimelineChartSidebar_4,
} from 'components/PlayerLineChart/PlayerLineChartSidebar';
import PitcherSessionPitchLocationChart from 'components/GridTiles/PitcherSessionPitchLocationChart/PitcherSessionPitchLocationChart';
import PitcherSessionPitchLocationChartSidebar from 'components/GridTiles/PitcherSessionPitchLocationChart/PitcherSessionPitchLocationChartSidebar';
import PitcherSingleSessionGameStatsChart from 'components/GridTiles/PitcherSingleSessionGameStatsChart/PitcherSingleSessionGameStatsChart';
import PitcherSingleSessionPitchByPitchStatsChart from 'components/GridTiles/PitcherSingleSessionPitchByPitchStatsChart/PitcherSingleSessionPitchByPitchStatsChart';
import PitcherSingleSessionPitchTypeRangesChart from 'components/GridTiles/PitcherSingleSessionPitchTypeRangesChart/PitcherSingleSessionPitchTypeRangesChart';
import PitcherSingleSessionPitchTypesUsageSummaryChart from 'components/GridTiles/PitcherSingleSessionPitchTypesUsageSummaryChart/PitcherSingleSessionPitchTypesUsageSummaryChart';
import PitcherSingleSessionStatsByPitchChart from 'components/GridTiles/PitcherSingleSessionStatsByPitchChart/PitcherSingleSessionStatsByPitchChart';
import PitcherSingleSessionGameStatsChartSidebar from 'components/GridTiles/PitcherSingleSessionGameStatsChart/PitcherSingleSessionGameStatsChartSidebar';
import PitcherSingleSessionStatsByPitchChartSidebar from 'components/GridTiles/PitcherSingleSessionStatsByPitchChart/PitcherSingleSessionStatsByPitchChartSidebar';
import PitcherSingleSessionPitchByPitchStatsChartSidebar from 'components/GridTiles/PitcherSingleSessionPitchByPitchStatsChart/PitcherSingleSessionPitchByPitchStatsChartSidebar';
import PitcherSingleSessionPitchTypeRangesChartSidebar from 'components/GridTiles/PitcherSingleSessionPitchTypeRangesChart/PitcherSingleSessionPitchTypeRangesChartSidebar';
import PitcherSingleSessionPitchLocationChart from 'components/GridTiles/PitcherSingleSessionPitchLocationChart/PitcherSingleSessionPitchLocationChart';
import PitcherSingleSessionPitchLocationChartSidebar from 'components/GridTiles/PitcherSingleSessionPitchLocationChart/PitcherSingleSessionPitchLocationChartSidebar';
import PitchingStatsChart from 'components/GridTiles/PitchingStatsChart/PitchingStatsChart';
import PitchingStatsChartSidebar from 'components/GridTiles/PitchingStatsChart/PitchingStatsChartSidebar';
import PitchTypeStatsChart from 'components/GridTiles/PitchTypeStatsChart/PitchTypeStatsChart';
import PitchTypeStatsChartSidebar from 'components/GridTiles/PitchTypeStatsChart/PitchTypeStatsChartSidebar';
import UmpireGamePerformanceChart from 'components/GridTiles/UmpireGamePerformanceChart/UmpireGamePerformanceChart';
import UmpirePitchCallChart from 'components/GridTiles/UmpirePitchCallChart/UmpirePitchCallChart';
import UmpirePerformanceSummaryChart from 'components/GridTiles/UmpirePerformanceSummaryChart/UmpirePerformanceSummaryChart';
import UmpireStrikeZoneAccuracyChart from 'components/GridTiles/UmpireStrikeZoneAccuracyChart/UmpireStrikeZoneAccuracyChart';
import UmpireStrikeZoneChart from 'components/GridTiles/UmpireStrikeZoneChart/UmpireStrikeZoneChart';
import UmpireTopAndBottomPerformanceChart from 'components/GridTiles/UmpireTopAndBottomPerformanceChart/UmpireTopAndBottomPerformanceChart';
import UmpireTrendsChart from 'components/GridTiles/UmpireTrendsChart/UmpireTrendsChart';
import UmpireStrikeZoneChartSidebar from 'components/GridTiles/UmpireStrikeZoneChart/UmpireStrikeZoneChartSidebar';
import UmpirePitchCallChartSidebar from 'components/GridTiles/UmpirePitchCallChart/UmpirePitchCallChartSidebar';
import UmpireGamePerformanceChartSidebar from 'components/GridTiles/UmpireGamePerformanceChart/UmpireGamePerformanceChartSidebar';
import UmpirePerformanceSummaryChartSidebar from 'components/GridTiles/UmpirePerformanceSummaryChart/UmpirePerformanceSummaryChartSidebar';
import UmpireTrendsChartSidebar from 'components/GridTiles/UmpireTrendsChart/UmpireTrendsChartSidebar';
import UmpireTopAndBottomPerformanceChartSidebar from 'components/GridTiles/UmpireTopAndBottomPerformanceChart/UmpireTopAndBottomPerformanceChartSidebar';
import PlayerScatterChart from 'components/PlayerScatterChart/PlayerScatterChart';
import {
  PitcherScatterChartSidebar_1,
  PitcherScatterChartSidebar_2,
  PitcherScatterChartSidebar_3,
  PitcherSessionScatterChartSidebar_1,
  PitcherSessionScatterChartSidebar_2,
  PitcherSessionScatterChartSidebar_3,
  PitcherSingleSessionScatterChartSidebar_1,
  PitcherSingleSessionScatterChartSidebar_2,
  PitcherSingleSessionScatterChartSidebar_3,
} from 'components/PlayerScatterChart/PlayerScatterChartSidebar';
import {
  BatterSessionStrikeZoneHeatmapChart,
  BatterStrikeZoneHeatmapChart,
  PitcherSessionStrikeZoneHeatmapChart,
  PitcherSingleSessionStrikeZoneHeatmapChart,
  PitcherStrikeZoneHeatmapChart,
} from 'components/StrikeZoneHeatmapChart/StrikeZoneHeatmapChart';
import {
  BatterSessionStrikeZoneHeatmapChartSidebar,
  BatterStrikeZoneHeatmapChartSidebar,
  PitcherSingleSessionStrikeZoneHeatmapChartSidebar,
  PitcherStrikeZoneHeatmapChartSidebar,
} from 'components/StrikeZoneHeatmapChart/StrikeZoneHeatmapChartSidebar';
import PlayerSprayOrSprayZoneChart from 'components/PlayerSprayOrSprayZoneChart/PlayerSprayOrSprayZoneChart';
import {
  BatterSessionSprayOrSprayZoneChartSidebar,
  BatterSprayOrSprayZoneChartSidebar,
} from 'components/PlayerSprayOrSprayZoneChart/PlayerSprayOrSprayZoneChartSidebar';
import PercentileRankingsChart from 'components/PercentileRankingsChart/PercentileRankingsChart';
import {
  BatterPercentileRankingsChartSidebar,
  PitcherPercentileRankingsChartSidebar,
} from 'components/PercentileRankingsChart/PercentileRankingsChartSidebar';

export type ChartProps<ChartType, Config> = {
  chartData: ChartType | undefined;
  isLoading: boolean;
  extraChartData: ExtraChartData<Config>;
};

export type ChartConfigProps<Config, Layout> = {
  extraChartData: ExtraChartData<Config>;
  setTempLayout: (newLayout: Layout) => void;
  tempLayout: Layout;
};

type ExtraChartData<Config> = Omit<Config, 'chartId' | 'chartDrawingInfo'>;

// Ecery report type must have a unique `type REPORT_TYPE_ChartDataKey`, and it must exclude all fields that do not contain `chartId`
// ...ReportResultDto is returend from Generate endpoint call
type PitcherPlayerReportChartDataKey = Exclude<keyof PitcherPlayerReportResultDto['chartData'][number], 'playerName'>;
type BatterPlayerReportChartDataKey = Exclude<keyof BatterPlayerReportResultDto['chartData'][number], 'playerName'>;

type PitcherSessionReportChartDataKey = Exclude<keyof PitcherSessionReportResultDto['chartData'][number], 'playerName'>;
type BatterSessionReportChartDataKey = Exclude<keyof BatterSessionReportResultDto['chartData'][number], 'playerName'>;

type PitcherSingleSessionReportChartDataKey = Exclude<keyof PitcherSingleSessionReportResultDto['chartData'][number], 'playerName'>;
type BatterSingleSessionReportChartDataKey = Exclude<keyof BatterSingleSessionReportResultDto['chartData'][number], 'playerName'>;

type UmpireReportChartDataKey = Exclude<keyof UmpireReportResultDto['chartData'][number], 'umpireName'>;
type UmpireReportForSessionChartDataKey = Exclude<keyof UmpireReportForSessionResultDto['chartData'][number], 'umpireName'>;
type UmpireReportForAdminChartDataKey = Exclude<keyof UmpireReportForAdminResultDto['chartData'][number], 'leagueName'>;

type ChartDataKey =
  | PitcherPlayerReportChartDataKey
  | BatterPlayerReportChartDataKey
  | PitcherSessionReportChartDataKey
  | BatterSessionReportChartDataKey
  | PitcherSingleSessionReportChartDataKey
  | BatterSingleSessionReportChartDataKey
  | UmpireReportChartDataKey
  | UmpireReportForSessionChartDataKey
  | UmpireReportForAdminChartDataKey;

type ChartSetup = {
  Chart: any; // `any` here doesn't matter, since the type will be inferred due to `as const`
  dataKey: ChartDataKey;
  Sidebar: any;
};

export const chartIdTochartSetup = {
  // Pitcher player report
  PitchesPerCountChart: { Chart: PitchesPerCountChart, dataKey: 'pitchesPerCountChartData', Sidebar: undefined },
  PitchTypeStatsChart: { Chart: PitchTypeStatsChart, dataKey: 'pitchTypeStatsChartData', Sidebar: PitchTypeStatsChartSidebar },
  PitcherBallTrackingStatsChart: {
    Chart: PitcherBallTrackingStatsChart,
    dataKey: 'ballTrackingStatsChartData',
    Sidebar: PitcherBallTrackingStatsChartSidebar,
  },
  PitcherPercentileRankingsChart: {
    Chart: PercentileRankingsChart,
    dataKey: 'percentileRankingsChartData',
    Sidebar: PitcherPercentileRankingsChartSidebar,
  },
  PitcherHeatmapChart: {
    Chart: PitcherStrikeZoneHeatmapChart,
    dataKey: 'pitcherHeatmapChartData',
    Sidebar: PitcherStrikeZoneHeatmapChartSidebar,
  },
  PitchingStatsChart: { Chart: PitchingStatsChart, dataKey: 'pitchingStatsChartData', Sidebar: PitchingStatsChartSidebar },
  PitcherScatterChart_1: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherScatterChartData_1',
    Sidebar: PitcherScatterChartSidebar_1,
  },
  PitcherScatterChart_2: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherScatterChartData_2',
    Sidebar: PitcherScatterChartSidebar_2,
  },
  PitcherScatterChart_3: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherScatterChartData_3',
    Sidebar: PitcherScatterChartSidebar_3,
  },

  // Batter player report
  BatterPercentileRankingsChart: {
    Chart: PercentileRankingsChart,
    dataKey: 'batterPercentileRankingsChartData',
    Sidebar: BatterPercentileRankingsChartSidebar,
  },
  BatterSprayChart: { Chart: PlayerSprayOrSprayZoneChart, dataKey: 'batterSprayChartData', Sidebar: BatterSprayOrSprayZoneChartSidebar },
  BatterHeatmapChart: {
    Chart: BatterStrikeZoneHeatmapChart,
    dataKey: 'batterHeatmapChartData',
    Sidebar: BatterStrikeZoneHeatmapChartSidebar,
  },
  BatterUsedPitchTypesChart: {
    Chart: BatterUsedPitchTypesChart,
    dataKey: 'batterUsedPitchTypesChartData',
    Sidebar: BatterUsedPitchTypesChartSidebar,
  },
  BatterApproachPerCountChart: { Chart: BatterApproachPerCountChart, dataKey: 'batterApproachPerCountChartData', Sidebar: undefined },
  BatterBallStrikeSummaryChart: {
    Chart: BatterBallStrikeSummaryChart,
    dataKey: 'batterBallStrikeSummaryChartData',
    Sidebar: BatterBallStrikeSummaryChartSidebar,
  },
  BattingStatsChart: {
    Chart: BatterBattingStatsChart,
    dataKey: 'battingStatsChartData',
    Sidebar: BattingStatsChartSidebar,
  },

  // Umpire report
  UmpireStrikeZoneChart: { Chart: UmpireStrikeZoneChart, dataKey: 'umpireStrikeZoneChartData', Sidebar: UmpireStrikeZoneChartSidebar },
  UmpireStrikeZoneAccuracyChart: { Chart: UmpireStrikeZoneAccuracyChart, dataKey: 'umpireStrikeZoneAccuracyChartData', Sidebar: undefined },
  UmpireGamePerformanceChart: {
    Chart: UmpireGamePerformanceChart,
    dataKey: 'umpireGamePerformanceChartData',
    Sidebar: UmpireGamePerformanceChartSidebar,
  },
  UmpirePitchCallChart: {
    Chart: UmpirePitchCallChart,
    dataKey: 'umpirePitchCallChartData',
    Sidebar: UmpirePitchCallChartSidebar,
  },
  UmpireTrendsChart: { Chart: UmpireTrendsChart, dataKey: 'umpireTrendsChartData', Sidebar: UmpireTrendsChartSidebar },
  UmpirePerformanceSummaryChart: {
    Chart: UmpirePerformanceSummaryChart,
    dataKey: 'umpirePerformanceSummaryChartData',
    Sidebar: UmpirePerformanceSummaryChartSidebar,
  },
  UmpireTopAndBottomPerformanceChart: {
    Chart: UmpireTopAndBottomPerformanceChart,
    dataKey: 'umpireTopBottomPerformanceChartData',
    Sidebar: UmpireTopAndBottomPerformanceChartSidebar,
  },

  // Pitcher session report
  PitcherSessionPitchTypeRangesChart: {
    Chart: PitcherSessionPitchTypeRangesChart,
    dataKey: 'pitcherSessionPitchTypeRangesChartData',
    Sidebar: PitcherSessionPitchTypeRangesChartSidebar,
  },
  PitcherSessionStatsByPitchTypeChart: {
    Chart: PitcherSessionStatsByPitchTypeChart,
    dataKey: 'pitcherSessionStatsByPitchTypeChartData',
    Sidebar: PitcherSessionStatsByPitchTypeChartSidebar,
  },
  PitcherSessionHeatmapChart: {
    Chart: PitcherSessionStrikeZoneHeatmapChart,
    dataKey: 'pitcherSessionHeatmapChartData',
    Sidebar: PitcherSingleSessionStrikeZoneHeatmapChartSidebar,
  },
  PitcherSessionTiltChart: {
    Chart: PitcherSessionTiltChart,
    dataKey: 'pitcherSessionTiltChartData',
    Sidebar: undefined,
  },
  PitcherSessionScatterChart_1: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherSessionScatterChartData_1',
    Sidebar: PitcherSessionScatterChartSidebar_1,
  },
  PitcherSessionScatterChart_2: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherSessionScatterChartData_2',
    Sidebar: PitcherSessionScatterChartSidebar_2,
  },
  PitcherSessionScatterChart_3: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherSessionScatterChartData_3',
    Sidebar: PitcherSessionScatterChartSidebar_3,
  },
  PitcherSessionTimelineChart_1: {
    Chart: PlayerTimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_1',
    Sidebar: PitcherSessionTimelineChartSidebar_1,
  },
  PitcherSessionTimelineChart_2: {
    Chart: PlayerTimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_2',
    Sidebar: PitcherSessionTimelineChartSidebar_2,
  },
  PitcherSessionTimelineChart_3: {
    Chart: PlayerTimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_3',
    Sidebar: PitcherSessionTimelineChartSidebar_3,
  },
  PitcherSessionTimelineChart_4: {
    Chart: PlayerTimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_4',
    Sidebar: PitcherSessionTimelineChartSidebar_4,
  },
  PitcherSessionPitchLocationChart: {
    Chart: PitcherSessionPitchLocationChart,
    dataKey: 'pitcherSessionPitchLocationChartData',
    Sidebar: PitcherSessionPitchLocationChartSidebar,
  },

  // Pitcher single session report
  PitcherSingleSessionPitchTypesUsageSummaryChart: {
    Chart: PitcherSingleSessionPitchTypesUsageSummaryChart,
    dataKey: 'pitcherSingleSessionPitchTypesUsageSummaryChartData',
    Sidebar: undefined,
  },
  PitcherSingleSessionPitchTypeRangesChart: {
    Chart: PitcherSingleSessionPitchTypeRangesChart,
    dataKey: 'pitcherSingleSessionPitchTypeRangesChartData',
    Sidebar: PitcherSingleSessionPitchTypeRangesChartSidebar,
  },
  PitcherSingleSessionStatsByPitchChart: {
    Chart: PitcherSingleSessionStatsByPitchChart,
    dataKey: 'pitcherSingleSessionStatsByPitchChartData',
    Sidebar: PitcherSingleSessionStatsByPitchChartSidebar,
  },
  PitcherSingleSessionHeatmapChart: {
    Chart: PitcherSingleSessionStrikeZoneHeatmapChart,
    dataKey: 'pitcherSingleSessionHeatmapChartData',
    Sidebar: PitcherSingleSessionStrikeZoneHeatmapChartSidebar,
  },
  PitcherSingleSessionScatterChart_1: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherSingleSessionScatterChartData_1',
    Sidebar: PitcherSingleSessionScatterChartSidebar_1,
  },
  PitcherSingleSessionScatterChart_2: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherSingleSessionScatterChartData_2',
    Sidebar: PitcherSingleSessionScatterChartSidebar_2,
  },
  PitcherSingleSessionScatterChart_3: {
    Chart: PlayerScatterChart,
    dataKey: 'pitcherSingleSessionScatterChartData_3',
    Sidebar: PitcherSingleSessionScatterChartSidebar_3,
  },
  PitcherSingleSessionPitchByPitchStatsChart: {
    Chart: PitcherSingleSessionPitchByPitchStatsChart,
    dataKey: 'pitcherSingleSessionPitchByPitchStatsChartData',
    Sidebar: PitcherSingleSessionPitchByPitchStatsChartSidebar,
  },
  PitcherSingleSessionGameStatsChart: {
    Chart: PitcherSingleSessionGameStatsChart,
    dataKey: 'pitcherSingleSessionGameStatsChartData',
    Sidebar: PitcherSingleSessionGameStatsChartSidebar,
  },
  PitcherSingleSessionPitchLocationChart: {
    Chart: PitcherSingleSessionPitchLocationChart,
    dataKey: 'pitcherSingleSessionPitchLocationChartData',
    Sidebar: PitcherSingleSessionPitchLocationChartSidebar,
  },
  PitcherSingleSessionPitchByPitchLineChart_1: {
    Chart: PlayerLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_1',
    Sidebar: undefined,
  },
  PitcherSingleSessionPitchByPitchLineChart_2: {
    Chart: PlayerLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_2',
    Sidebar: undefined,
  },
  PitcherSingleSessionPitchByPitchLineChart_3: {
    Chart: PlayerLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_3',
    Sidebar: undefined,
  },
  PitcherSingleSessionPitchByPitchLineChart_4: {
    Chart: PlayerLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_4',
    Sidebar: undefined,
  },

  // Batter session report
  BatterSessionHeatmapChart: {
    Chart: BatterSessionStrikeZoneHeatmapChart,
    dataKey: 'batterSessionHeatmapChartData',
    Sidebar: BatterSessionStrikeZoneHeatmapChartSidebar,
  },
  BatterSessionSprayChart: {
    Chart: PlayerSprayOrSprayZoneChart,
    dataKey: 'batterSessionSprayChartData',
    Sidebar: BatterSessionSprayOrSprayZoneChartSidebar,
  },
  BatterSessionStatsByPitchTypeChart: {
    Chart: BatterSessionStatsByPitchTypeChart,
    dataKey: 'batterSessionStatsByPitchTypeChartData',
    Sidebar: BatterSessionStatsByPitchTypeChartSidebar,
  },
  BatterSessionTimelineChart_1: {
    Chart: BatterSessionTimelineChart,
    dataKey: 'batterSessionTimelineChartData_1',
    Sidebar: BatterSessionTimelineChartSidebar_1,
  },
  BatterSessionTimelineChart_2: {
    Chart: BatterSessionTimelineChart,
    dataKey: 'batterSessionTimelineChartData_2',
    Sidebar: BatterSessionTimelineChartSidebar_2,
  },
  BatterSessionTimelineChart_3: {
    Chart: BatterSessionTimelineChart,
    dataKey: 'batterSessionTimelineChartData_3',
    Sidebar: BatterSessionTimelineChartSidebar_3,
  },
  BatterSessionTimelineChart_4: {
    Chart: BatterSessionTimelineChart,
    dataKey: 'batterSessionTimelineChartData_4',
    Sidebar: BatterSessionTimelineChartSidebar_4,
  },

  // Batter single session report
  BatterSingleSessionPitchLocationChart: {
    Chart: BatterSingleSessionPitchLocationChart,
    dataKey: 'batterSingleSessionPitchLocationChartData',
    Sidebar: BatterSingleSessionPitchLocationChartSidebar,
  },
  BatterSingleSessionContactPointChart: {
    Chart: BatterSingleSessionContactPointChart,
    dataKey: 'batterSingleSessionContactPointChartData',
    Sidebar: undefined,
  },
  BatterSingleSessionGameStatsChart: {
    Chart: BatterSingleSessionGameStatsChart,
    dataKey: 'batterSingleSessionGameStatsChartData',
    Sidebar: BatterSingleSessionGameStatsChartSidebar,
  },
  BatterSingleSessionPitchByPitchStatsChart: {
    Chart: BatterSingleSessionPitchByPitchStatsChart,
    dataKey: 'batterSingleSessionPitchByPitchStatsChartData',
    Sidebar: BatterSingleSessionPitchByPitchStatsChartSidebar,
  },
  BatterSingleSessionBattingStatChart_1: {
    Chart: BatterSingleSessionGameStatHighlightChart,
    dataKey: 'batterSingleSessionBattingStatChartData_1',
    Sidebar: BatterSingleSessionBattingStatChartSidebar_1,
  },
  BatterSingleSessionBattingStatChart_2: {
    Chart: BatterSingleSessionGameStatHighlightChart,
    dataKey: 'batterSingleSessionBattingStatChartData_2',
    Sidebar: BatterSingleSessionBattingStatChartSidebar_2,
  },
  BatterSingleSessionBattingStatChart_3: {
    Chart: BatterSingleSessionGameStatHighlightChart,
    dataKey: 'batterSingleSessionBattingStatChartData_3',
    Sidebar: BatterSingleSessionBattingStatChartSidebar_3,
  },
  BatterSingleSessionBattingStatChart_4: {
    Chart: BatterSingleSessionGameStatHighlightChart,
    dataKey: 'batterSingleSessionBattingStatChartData_4',
    Sidebar: BatterSingleSessionBattingStatChartSidebar_4,
  },
  BatterSingleSessionBattingStatChart_5: {
    Chart: BatterSingleSessionGameStatHighlightChart,
    dataKey: 'batterSingleSessionBattingStatChartData_5',
    Sidebar: BatterSingleSessionBattingStatChartSidebar_5,
  },
  BatterSingleSessionBattingStatChart_6: {
    Chart: BatterSingleSessionGameStatHighlightChart,
    dataKey: 'batterSingleSessionBattingStatChartData_6',
    Sidebar: BatterSingleSessionBattingStatChartSidebar_6,
  },
} as const satisfies Record<ChartType, ChartSetup>;
